<div class="layout-wrapper">
    <!-- Authorized Layout -->
    <div class="flex flex-column justify-content-between min-h-screen layout"
        [ngClass]="{'collapsed-sidebar': isMenuCollapsed, 'expanded-sidebar': !isMenuCollapsed}">
        <div class="relative">
            <div class="flex-1 flex flex-column">
                @if (isLoggedIn) {
                <app-sidebar [items]="menuItems" [isLoggedIn]="isLoggedIn" class="z-5"></app-sidebar>
                <div name="header">
                    <app-sticky-header class="hidden md:block"></app-sticky-header>
                    <app-mobile-header class="md:hidden" [items]="menuItems"
                        [isLoggedIn]="isLoggedIn"></app-mobile-header>
                </div>
                }
                <div class="flex-1 flex flex-column"
                    [ngClass]="{'py-4 px-3 md:py-3 md:px-4 md:mt-6 z-0 main-content main-container': isLoggedIn}">
                    <div class="flex-1">
                        <div class="flex flex-column w-full">
                            <div class="w-full flex flex-column authorized-layout" [ngClass]="{'min-h-screen': !isLoggedIn}">
                                @if(!isLoggedIn) {
                                <div class="flex flex-column relative">
                                    <div
                                        class="w-full bg-blue-sara h-12rem flex justify-content-center align-items-center mobile-hide">
                                        <img src="assets/images/logo/SARAWhiteLogoBorderless.png" alt="Sara Plus Logo"
                                            class="w-15rem">
                                    </div>
                                    <div
                                        class="bg-blue-sara h-4rem flex justify-content-between mobile-show sticky top-0 z-10">
                                        <div class="pt-2 pl-2">
                                            <img src="assets/images/logo/SARAPlusLogoWhite.png" alt="Sara Plus Logo"
                                                class="w-3rem">
                                        </div>
                                    </div>
                                </div>
                                }
                                <div
                                    class="p-2 sm:p-4 flex-1 justify-content-center sm:align-content-center pt-8 sm:pt-0">
                                    <router-outlet></router-outlet>
                                </div>

                                @if(!isLoggedIn) {
                                <div
                                    class="p-2 sm:p-4 flex-1 justify-content-center sm:align-content-center pt-8 sm:pt-0">
                                    <ng-content></ng-content>
                                </div>

                                <div
                                    class="flex flex-column align-items-center pb-7 justify-content-end w-full h-12rem">
                                    <p-button [label]="'Terms of Use and Privacy Policy'" [link]="true"
                                        (click)="showPivacyTerms()"
                                        styleClass="font-italic text-lg text-color-secondary"></p-button>
                                </div>
                                <p-dialog styleClass="w-full md:w-9 lg:w-10 xl:w-9" [(visible)]="privacyTerms">
                                    <app-privacy-policy></app-privacy-policy>
                                </p-dialog>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </div>
        </div>
    </div>
    @if (isLoggedIn) {
    <app-session-timeout #sessionTimeout (SessionExpired)="onSessionExpired()" (ContinueClicked)="onSessionresume()"
        (LogoutClicked)="onLogoutClicked()"
        [setting]="{ idle: +environment.sessionIdle, timeout: +environment.sessionTimeout }"></app-session-timeout>
    }
</div>